const ProductTypesDisplayText = ({ title = '', subtitle = '' }) => ({
  title: String(title),
  subtitle: String(subtitle),
});

export const Adproduct = ({
  updateCtaUrl = '',
  updateCtaText = '',
  hasBoost = false,
  isEligibleForUpdate = false,
  isEligibleForReleaseClaim = false,
  isUnpaid = false,
  unpaidCustomerId = '',
  productTypes = [],
  productTypesDisplayText = {},
}) => ({
  hasBoost: Boolean(hasBoost),
  isEligibleForUpdate: Boolean(isEligibleForUpdate),
  isEligibleForReleaseClaim: Boolean(isEligibleForReleaseClaim),
  updateCtaText: String(updateCtaText),
  updateCtaUrl: String(updateCtaUrl),
  isUnpaid: Boolean(isUnpaid),
  unpaidCustomerId: String(unpaidCustomerId),
  productTypes: [...productTypes],
  productTypesDisplayText: ProductTypesDisplayText(productTypesDisplayText),
});

export type AdproductProps = ReturnType<typeof Adproduct>;
